import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PropertiesBulkOperationConfirmModal from './modal';

@modal(
  {
    className: 'properties-bulk-operation-confirm-modal',
  },
  true,
)
class PropertiesBulkOperationConfirmContainer extends React.Component {
  render() {
    const { selectedProperties } = this.props;

    return (
      <PropertiesBulkOperationConfirmModal
        selectedProperties={selectedProperties}
        onClose={this.props.handleCloseModal}
        onSuccess={this.props.onSuccess}
        list={this.props.list}
      />
    );
  }
}

PropertiesBulkOperationConfirmContainer.propTypes = {
  t: PropTypes.func.isRequired,
  selectedProperties: PropTypes.array.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  list: PropTypes.array,
};

PropertiesBulkOperationConfirmContainer.defaultProps = {
  t: () => {},
  selectedProperties: [],
  list: [],
  handleCloseModal: () => {},
  onSuccess: () => {},
};

export default PropertiesBulkOperationConfirmContainer;
